module.exports = {
  "attach": {
    "button-text": "Выбрать файл",
    "no-file": "файл не выбран"
  }
};